import moment from 'moment'

// "async" is optional
export default moment